export const getSalesSpaceListState = (state) => state.salesSpaceChannels;
